export default __webpack_public_path__ + "static/media/room-2Bed-twin_compressed.d0dd06d5.mp4";